import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class MediaServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params = {}) {
    return this.pure_http.get(`pbx/client/select/mediafiles`, { params });
  }

  removeItem(id) {
    return this.http.delete(`/${id}`);
  }
}

export const MediaService = new MediaServiceClass({
  api_version: 2,
  resource: 'pbx/mediafiles'
});
